// steps
import personalLoanSteps from '@/form/products/CA/personal_loan.js';

// products CA
import debtConsolidationSteps from '@/form/products/CA/debt_consolidation.js';
import carLoanSteps from '@/form/products/CA/car_loan.js';
import lifeInsuranceSteps from '@/form/products/CA/life_insurance.js';
import mortgageContactInfoSteps from '@/form/products/CA/mortgage_contact_info.js';
import powersportsSteps from '@/form/products/CA/powersports.js';
import businessLoanSteps from '@/form/products/CA/business_loan.js';
import carRefinancingSteps from '@/form/products/CA/car_refinancing.js';
import debtSettlementSteps from '@/form/products/CA/debt_settlement.js';
import paymentProcessingSteps from '@/form/products/CA/payment_processing.js';
import posFinancingSteps from '@/form/products/CA/pos_financing.js';

// products US
import personalLoanStepsUs from '@/form/products/US/personal_loan.js';
import personalLoanStepsUsWithBanking from '@/form/products/US/personal_loan_with_banking.js';
import mortgageContactInfoStepsUs from '@/form/products/US/mortgage_contact_info.js';


const STEPS_PER_PRODUCT = {
    CA: {
        // === Loan ===
        personal_loan: personalLoanSteps,
        // === Car & Powesports ===
        car_loan: carLoanSteps,
        car_refinancing: carRefinancingSteps,
        powersports: powersportsSteps,
        // === Debt ===
        debt_consolidation: debtConsolidationSteps,
        debt_settlement: debtSettlementSteps,
        consumer_proposal: debtSettlementSteps,
        bankruptcy: debtSettlementSteps,
        // === Business ===
        business_loan: businessLoanSteps,
        mca: businessLoanSteps,
        payment_processing: paymentProcessingSteps,
        pos_financing: posFinancingSteps,
        // === Mortgage ===
        heloc: mortgageContactInfoSteps,
        mortgage: mortgageContactInfoSteps,
        commercial_mortgage: mortgageContactInfoSteps,
        mortgage_refinancing: mortgageContactInfoSteps,
        mortgage_renewal: mortgageContactInfoSteps,
        reverse_mortgage: mortgageContactInfoSteps,
        second_mortgage: mortgageContactInfoSteps,
        bridge_loan: mortgageContactInfoSteps,
        // === Other ===
        life_insurance: lifeInsuranceSteps,
    },
    US: {
        personal_loan: personalLoanStepsUs,
        personal_loan_with_banking: personalLoanStepsUsWithBanking,
        heloc: mortgageContactInfoStepsUs,
    }
}

export { STEPS_PER_PRODUCT };

export function getSteps(product, country = 'CA') {
    country = country.toUpperCase();
    return STEPS_PER_PRODUCT[country][product] ?? STEPS_PER_PRODUCT[country]['personal_loan'] ?? STEPS_PER_PRODUCT['CA']['personal_loan'];
}
